module.exports = __webpack_public_path__ + "static/media/brenchmarkWitnessLogo.bafcbfe1.webp";